import Phaser from 'phaser';

import phaserConfig from './config/phaser';


export default class ScrApp{

    constructor(){
        window.GAME_REF = {
            game: null,
            scene: null,
            obj: {}
        };

        this.$game = null;
        this.$loader = null;
        this._init();
    }


    render(){
        this._createGame();
    }


    _init(){
        this.$game = document.querySelector('#js-scr-game');
        this.$loader = document.querySelector('.js-loader');
    }


    _createGame(){
        const game = new Phaser.Game(phaserConfig);
        this.$game.classList.add('-active');
        this.$loader.classList.add('-active');
        GAME_REF.game = game;
    }
}